import React from "react";
import ClassStudentList from "../pages/list/ClassStudentList";

const Teacher = React.lazy(() => import("../pages/home/teacher/Teacher"));

export const teacherRoutes = [
  {
    path: "/teacher",
    element: <Teacher />,
    title: "Teacher Dashboard",
    description: "Central hub for teachers to manage their classes, students, and academic activities.",
  },
  {
    path: "/class-students",
    element: <ClassStudentList />,
    title: "Class Students",
    description: "View and manage students in your assigned class, including their academic records and personal information.",
    requiredAnyPermission: ["classStudentsView", "studentsView"],
  },
];
